<template>
  <tr>
    <td v-if="selectable">
      <a-checkbox ref="checkbox"
                  :checked="isSelected"
                  @change="onSelectionChanged"
                  v-on:click.stop/>
    </td>
    <td>
      <a href="">{{ sharedSignalQuery.name }}</a>
    </td>
    <td v-if="displayInterval" class="compact text-center">{{ sharedSignalQuery.interval_description }}</td>
    <td v-if="displayInterval && (sharedSignalQuery.recurring == '1')" class="compact text-center">
      Terugkerend
    </td>
    <td v-else-if="displayRecurring" class="compact text-center">
      Eenmalig
    </td>
    <td v-if="displayUsersCount" class="compact text-center">{{ sharedSignalQuery.users_count }}</td>
    <td v-if="displayDepartmentsCount" class="compact text-center">{{ sharedSignalQuery.departments_count }}</td>
    <td v-if="displaySignalsCount" class="compact text-center">{{ sharedSignalQuery.signal_count }}</td>
    <td v-if="displayAutoProcess" class="compact text-center">
      {{ parseAutoProcessDays(sharedSignalQuery) }}
    </td>
    <td class="compact text-center" v-if="displayVisibleForCustomer">
      Nee
    </td>
    <td class="compact">
      <div class="pull-right">
        <a-tooltip placement="left">
          <template slot="title">Kopieer template</template>
          <a-button @click.stop="onCopyTemplateClick">
            <content-copy-icon></content-copy-icon>
          </a-button>
        </a-tooltip>
        <a-popconfirm v-if="canDetachUser && !isDetached"
                      @confirm="onDetachFromSignal()"
                      cancel-text="Nee"
                      ok-text="Ja"
                      placement="topRight"
                      title="Weet u zeker dat u zich voor dit signaal wilt afmelden."
                      v-on:click.stop
        >
          <a-tooltip placement="left">
            <template slot="title">
              <span>Mij afmelden voor het signaal</span>
            </template>
            <a-button type="danger" v-on:click.stop>
              <close-octagon-icon></close-octagon-icon>
            </a-button>
          </a-tooltip>
        </a-popconfirm>
        <a-tooltip v-else-if="displayDetachDepartmentMessage" placement="left">
          <template slot="title">
            <span>U krijgt dit signaal via een afdeling. Om dit te veranderen moet u de afdeling verlaten of moet de afdeling bij het signaal worden verwijderd. Overleg met de beheerder wat het handigst is in uw situatie</span>
          </template>
          <a-button type="disabled" v-on:click.stop>
            <close-octagon-icon></close-octagon-icon>
          </a-button>
        </a-tooltip>
      </div>
    </td>
  </tr>
</template>

<script>
import store from '../../../store';
import signalModule from '../store'
import sharedSignalQueryApi from '~/api/sharedSignalQuery'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "SharedSignalQueryRowComponent",
  props: {
    query: {
      type: Object,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    displayInterval: {
      type: Boolean,
      required: false,
      default: true
    },
    displayRecurring: {
      type: Boolean,
      required: false,
      default: true
    },
    displayUsersCount: {
      type: Boolean,
      required: false,
      default: true
    },
    displayDepartmentsCount: {
      type: Boolean,
      required: false,
      default: true
    },
    displaySignalsCount: {
      type: Boolean,
      required: false,
      default: true
    },
    displayAutoProcess: {
      type: Boolean,
      required: false,
      default: true
    },
    canDetachUser: {
      type: Boolean,
      required: false,
      default: false
    },
    displayDetachDepartmentMessage: {
      type: Boolean,
      required: false,
      default: false
    },
    displayVisibleForCustomer: {
      type: Boolean,
      required: false,
      default: false
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false
    },
    canSubscribe: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      sharedSignalQuery: this.query,
      isDetached: false
    }
  },
  computed: {
    ...mapGetters('signal', [
      'selectedSharedQueries',
    ]),
    isSelected() {
      return Object.values(this.selectedSharedQueries).includes(this.sharedSignalQuery)
    }
  },
  created() {
    if (!store.hasModule('signal')) {
      store.registerModule('signal', signalModule)
    }
  },
  methods: {
    ...mapActions('signal', [
      'selectSharedQuery',
      'deselectSharedQuery',
    ]),
    parseAutoProcessDays(query) {
      if ((query.auto_process === 1) && (query.process_after > 0)) {
        if (query.process_after === 1) {
          return 'Na 1 dag'
        }
      } else if (query.process_after > 1) {
        return 'Na ' + query.process_after + ' dagen';
      }

      return 'Nee'
    },
    onCopyTemplateClick() {
      window.location.href = '/signal/query/create?shared=' + this.sharedSignalQuery.id;
    },
    onDetachFromSignal() {
      sharedSignalQueryApi.detachUserFromQuery(this.userId, this.sharedSignalQuery.id).then(() => {
        this.reloadQuery();
        this.isDetached = true;
      })
    },
    reloadQuery() {
      sharedSignalQueryApi.get(this.sharedSignalQuery.id).then((response) => {
        this.sharedSignalQuery = response.data;
      })
    },
    onSelectionChanged() {
      if (this.isSelected) {
        this.deselectSharedQuery(this.sharedSignalQuery)
      } else {
        this.selectSharedQuery(this.sharedSignalQuery)
      }
    },
  }
}
</script>

<style scoped>

</style>